export default __webpack_public_path__ + "static/media/EngCapaBtn.f7e2020a.png";